import { Space, Tag, Typography } from 'antd'

const { Text } = Typography

function hasEmployeeOverallRating (appraisal) {
  return appraisal?.status === 'completed' && Boolean(appraisal?.employee_overall_rating)
}

function hasFinalOverallRating (appraisal) {
  return appraisal?.status === 'completed' && Boolean(appraisal?.approver_overall_rating)
}

function supportsEmployeeOverallRating (appraisal) {
  if (typeof appraisal?.supports_employee_overall_rating === 'boolean') {
    return appraisal.supports_employee_overall_rating
  }
  return hasEmployeeOverallRating(appraisal)
}

export function CompletedRating ({ appraisal, field }) {
  if (appraisal.status !== 'completed') return <Text type='secondary'>—</Text>
  return appraisal[field] || <Text type='secondary'>Not rated</Text>
}

export function completedRatingColumns (appraisals = []) {
  const columns = []

  if ((appraisals || []).some(supportsEmployeeOverallRating)) {
    columns.push({
      title: 'Employee Rating',
      key: 'employee_rating',
      render: (_, appraisal) => <CompletedRating appraisal={appraisal} field='employee_overall_rating' />
    })
  }

  if ((appraisals || []).some(hasFinalOverallRating)) {
    columns.push({
      title: 'Final Rating',
      key: 'approver_rating',
      render: (_, appraisal) => <CompletedRating appraisal={appraisal} field='approver_overall_rating' />
    })
  }

  return columns
}

export default function CompletedAppraisalRatings ({ appraisal }) {
  if (appraisal.status !== 'completed') return null

  return (
    <Space size={[4, 4]} wrap>
      {supportsEmployeeOverallRating(appraisal) && (
        <Tag>Employee Rating: {appraisal.employee_overall_rating || 'Not rated'}</Tag>
      )}
      {hasFinalOverallRating(appraisal) && (
        <Tag color='blue'>Final Rating: {appraisal.approver_overall_rating}</Tag>
      )}
    </Space>
  )
}
